/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_footer_socials_find_us = /** @type {(inputs: {}) => string} */ () => {
	return `Najděte nás na sociálních sítích`
};

const da_footer_socials_find_us = /** @type {(inputs: {}) => string} */ () => {
	return `Find os på sociale medier`
};

const de_footer_socials_find_us = /** @type {(inputs: {}) => string} */ () => {
	return `Folgen Sie uns in den sozialen Netzwerken`
};

const en_footer_socials_find_us = /** @type {(inputs: {}) => string} */ () => {
	return `Find us on social networks`
};

const es_footer_socials_find_us = /** @type {(inputs: {}) => string} */ () => {
	return `Encuéntranos en las redes sociales`
};

const fr_footer_socials_find_us = /** @type {(inputs: {}) => string} */ () => {
	return `Retrouvez-nous sur les réseaux sociaux`
};

const hu_footer_socials_find_us = /** @type {(inputs: {}) => string} */ () => {
	return `Keress minket a közösségi oldalakon`
};

const it_footer_socials_find_us = /** @type {(inputs: {}) => string} */ () => {
	return `Seguici sui social`
};

const nl_footer_socials_find_us = /** @type {(inputs: {}) => string} */ () => {
	return `Volg ons op sociale media`
};

const pl_footer_socials_find_us = /** @type {(inputs: {}) => string} */ () => {
	return `Znajdź nas w mediach społecznościowych`
};

const pt_footer_socials_find_us = /** @type {(inputs: {}) => string} */ () => {
	return `Encontre-nos nas redes sociais`
};

const sv_footer_socials_find_us = /** @type {(inputs: {}) => string} */ () => {
	return `Följ oss på sociala medier`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const footer_socials_find_us = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.footer_socials_find_us(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("footer_socials_find_us", locale)
	if (locale === "cs") return cs_footer_socials_find_us(inputs)
	if (locale === "da") return da_footer_socials_find_us(inputs)
	if (locale === "de") return de_footer_socials_find_us(inputs)
	if (locale === "en") return en_footer_socials_find_us(inputs)
	if (locale === "es") return es_footer_socials_find_us(inputs)
	if (locale === "fr") return fr_footer_socials_find_us(inputs)
	if (locale === "hu") return hu_footer_socials_find_us(inputs)
	if (locale === "it") return it_footer_socials_find_us(inputs)
	if (locale === "nl") return nl_footer_socials_find_us(inputs)
	if (locale === "pl") return pl_footer_socials_find_us(inputs)
	if (locale === "pt") return pt_footer_socials_find_us(inputs)
	return sv_footer_socials_find_us(inputs)
};
export { footer_socials_find_us as "footer.socials.find_us" }